export var CTA_VARIANT = {
  Primary: 'Button',
  Link: 'Text Link'
};
export var CTA_POSITIONS = {
  BELOW_MEDIA: 'below-media',
  ABOVE_MEDIA: 'above-media'
};